export function debugLog(...items) {
    console.log(...items)
} 

export function errorLog(...items) {
    console.error(...items)
} 
